import "./About.module.css";
import Header from "@/reusable_sections/Header";
import NaplesAParis from "./sections/NaplesAParis";
import GetMovingToday from "./sections/GetMovingToday";
import YeFooter from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <NaplesAParis />
      <GetMovingToday />
      <YeFooter />
    </div>;
}